var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarBackArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 10,
  viewBox: "0 0 8 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.231719 5.6V4.24L7.51172 0.139999V1.98L2.03172 4.92L7.51172 7.86V9.7L0.231719 5.6Z",
  fill: "#1D1B20"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_back_arrow.eef130610bb314a814f6abacc78bb87f.svg";